import { TFPageContent, TFPageHeader } from '@tf/shared';
import { T } from '@tf/utils';

import { appStore } from '@/core/stores';
import { PaymentsTable } from '@/components/payments';

export const PaymentsListRoute = () => {
	const tenant = appStore.tenant?.get();
	T.assertNotNullish(tenant, 'no tenant in appStore');

	return (
		<>
			<TFPageHeader sx={{ marginBottom: 0 }} tenant={tenant} title="Payments" />
			<TFPageContent>
				<PaymentsTable />
			</TFPageContent>
		</>
	);
};
